enum ConversationTopicStatus {
    Active = 90,
    Deleted = 100
}

export default ConversationTopicStatus;